export enum CategoryToursDashboardTypes {
  FETCH_CATEGORY_TOURS_START = 'FETCH_CATEGORY_TOURS_START',
  FETCH_CATEGORY_TOURS_SUCCESS = 'FETCH_CATEGORY_TOURS_SUCCESS',
  FETCH_CATEGORY_TOURS_FAILURE = 'FETCH_CATEGORY_TOURS_FAILURE',
  UPDATE_CATEGORY_TOUR_START = 'UPDATE_CATEGORY_TOUR_START',
  UPDATE_CATEGORY_TOUR_SUCCESS = 'UPDATE_CATEGORY_TOUR_SUCCESS',
  UPDATE_CATEGORY_TOUR_FAILURE = 'UPDATE_CATEGORY_TOUR_FAILURE',
}
